
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.097 1.671C13.054 1.104 12.713.8 12.06.8H4.998c-.653 0-.994.304-1.037.871h9.136zm1.39 1.872c-.106-.615-.41-.953-1.12-.953H3.55c-.71 0-1.015.338-1.122.953h12.06zM13.836 16c1.483 0 2.229-.703 2.229-2.094V6.73c0-1.391-.746-2.094-2.23-2.094H3.075c-1.49 0-2.229.696-2.229 2.094v7.175c0 1.391.739 2.094 2.23 2.094h10.76zm-5.373-4.492c-1.2-.014-2.172-.973-2.172-2.264 0-1.209.972-2.195 2.172-2.195 1.2 0 2.165.986 2.165 2.195 0 1.29-.966 2.27-2.165 2.264zm4.4 3.404H4.054c.575-1.108 1.994-2.465 4.393-2.465 2.4 0 3.84 1.357 4.415 2.465z","fill":"#1AAA97","fill-rule":"nonzero"}})])
          )
        }
      }
    